var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header" }, [
    _c("div", [
      _vm.switchIndex == 2
        ? _c(
            "div",
            { staticClass: "header-left" },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.allMove } },
                [_vm._v("移动至")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.allDelete(1)
                    },
                  },
                },
                [_vm._v("删除")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.switchIndex == 3
        ? _c(
            "div",
            { staticClass: "header-left" },
            [
              _c(
                "el-tabs",
                {
                  staticClass: "tab-share",
                  on: { "tab-click": _vm.handleClick },
                  model: {
                    value: _vm.type,
                    callback: function ($$v) {
                      _vm.type = $$v
                    },
                    expression: "type",
                  },
                },
                [
                  _c("el-tab-pane", {
                    attrs: { label: "共享给我", name: "1" },
                  }),
                  _vm._v(" "),
                  _c("el-tab-pane", {
                    attrs: { label: "我的共享", name: "2" },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.switchIndex == 4 || _vm.switchIndex == 5
        ? _c(
            "div",
            { staticClass: "header-left" },
            [
              _vm.switchIndex == 4
                ? _c(
                    "el-dropdown",
                    {
                      attrs: { trigger: "click" },
                      on: { command: _vm.handleScreen },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            icon: "el-icon-plus",
                            size: "small",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("file.newlybuild")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        _vm._l(_vm.newlyBuildData, function (item) {
                          return _c(
                            "el-dropdown-item",
                            {
                              key: item.id,
                              staticStyle: { width: "160px" },
                              attrs: {
                                divided: item.divided,
                                placement: "top-end",
                                command: item.id,
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "icon iconfont",
                                class: item.icon,
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(item.name))]),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.switchIndex == 4
                ? _c(
                    "el-upload",
                    {
                      staticClass: "upload",
                      attrs: {
                        action: _vm.fileUrl,
                        "on-success": _vm.handleSuccess,
                        headers: _vm.myHeaders,
                        "show-file-list": false,
                        "before-upload": _vm.handleUpload,
                        data: _vm.uploadData,
                        multiple: "",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "ml10 mr10",
                          attrs: { plain: "", size: "small" },
                        },
                        [_vm._v(_vm._s(_vm.$t("file.upload")))]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { plain: "", size: "small" },
                  on: { click: _vm.allMove },
                },
                [_vm._v(_vm._s(_vm.$t("file.moveto")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { plain: "", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.allDelete(1)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("public.delete")))]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.switchIndex == 6 || _vm.switchIndex == 1
        ? _c("div", { staticClass: "header-16 mt20" }, [
            _c(
              "div",
              { staticClass: "title-16" },
              [
                _vm.breadcrumbArray.length == 0
                  ? _c("div", [_vm._v("最近打开")])
                  : _c(
                      "el-breadcrumb",
                      { attrs: { "separator-class": "el-icon-arrow-right" } },
                      _vm._l(_vm.breadcrumbArray, function (item, indexJ) {
                        return _c(
                          "el-breadcrumb-item",
                          {
                            key: indexJ,
                            nativeOn: {
                              click: function ($event) {
                                return _vm.getBreadcrumb(item.pid, indexJ)
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "breadcrumb-item",
                                style: {
                                  color:
                                    indexJ == _vm.breadcrumbArray.length - 1
                                      ? "#303133"
                                      : "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item ? item.name : "--") +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      1
                    ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.spaceId && _vm.breadcrumbArray.length != 0
              ? _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c(
                      "el-dropdown",
                      {
                        staticClass: "mr10 ml14",
                        attrs: { trigger: "click" },
                        on: { command: _vm.handleScreen },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              icon: "el-icon-plus",
                              size: "small",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("file.newlybuild")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          _vm._l(_vm.newlyBuildData, function (item) {
                            return _c(
                              "el-dropdown-item",
                              {
                                key: item.id,
                                staticStyle: { width: "160px" },
                                attrs: {
                                  divided: item.divided,
                                  placement: "top-end",
                                  command: item.id,
                                },
                              },
                              [
                                item.id !== 6
                                  ? [
                                      _c("i", {
                                        staticClass: "icon iconfont",
                                        class: item.icon,
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v(_vm._s(item.name))]),
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                item.id == 6
                                  ? _c(
                                      "el-upload",
                                      {
                                        ref: "upload",
                                        refInFor: true,
                                        staticClass: "upload-list",
                                        attrs: {
                                          action: _vm.fileUrl,
                                          "on-success": _vm.handleSuccess,
                                          headers: _vm.myHeaders,
                                          "show-file-list": false,
                                          "before-upload": _vm.handleUpload,
                                          data: _vm.uploadData,
                                          multiple: "",
                                        },
                                      },
                                      [
                                        _c("div", [
                                          _c("i", {
                                            staticClass: "icon iconfont",
                                            class: item.icon,
                                          }),
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(item.name) +
                                              "\n                "
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              2
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-dropdown",
                      { attrs: { trigger: "hover" } },
                      [
                        _c("span", { staticClass: "el-dropdown-link" }, [
                          _c("i", {
                            staticClass: "iconfont icongengduo2 fz30 pointer",
                          }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c(
                              "el-dropdown-item",
                              {
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.allMove($event)
                                  },
                                },
                              },
                              [_vm._v("移动至")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-dropdown-item",
                              {
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.allDelete(3)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.switchIndex == 7
        ? _c(
            "div",
            { staticClass: "header-left mt20" },
            [
              _c(
                "el-button",
                {
                  attrs: { plain: "", size: "small" },
                  on: { click: _vm.allDestroy },
                },
                [_vm._v(_vm._s(_vm.$t("file.restorefile")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { plain: "", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.allDelete(2)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("file.completelydelete")))]
              ),
              _vm._v(" "),
              _vm.entButton
                ? _c(
                    "el-button",
                    {
                      attrs: { plain: "", size: "small" },
                      on: { click: _vm.returnSpace },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("file.returnspace")) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", [
      _c("div", { staticClass: "header-16" }, [
        _c(
          "div",
          { class: _vm.breadcrumbArray.length > 0 ? "mt8" : "mt14" },
          [
            _c("span", { staticClass: "total-16" }, [
              _vm._v("共" + _vm._s(_vm.total) + "项"),
            ]),
            _vm._v(" "),
            _c("el-input", {
              staticStyle: { width: "250px" },
              attrs: {
                placeholder: "搜索文件名称",
                "prefix-icon": "el-icon-search",
                size: "small",
                clearable: "",
              },
              on: {
                change: function ($event) {
                  return _vm.getStyle()
                },
              },
              model: {
                value: _vm.fileStyle.keyword,
                callback: function ($$v) {
                  _vm.$set(_vm.fileStyle, "keyword", $$v)
                },
                expression: "fileStyle.keyword",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "flex",
            class: _vm.breadcrumbArray.length > 0 ? "mt8" : "mt14",
          },
          [
            _vm.switchIndex !== 1
              ? _c("div", { staticClass: "mr10 icon-name" }, [
                  _c(
                    "div",
                    { staticClass: "el-dropdown sort-dropdown display-align" },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "el-dropdown-link pointer el-dropdown-selfdefine text-16",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.handleSortShow($event)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              " + _vm._s(_vm.sortName) + " "
                          ),
                          _c("i", { staticClass: "icon iconfont iconpaixu" }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isSortShow,
                              expression: "isSortShow",
                            },
                          ],
                          staticClass: "sort-content",
                        },
                        [
                          _c(
                            "ul",
                            {
                              staticClass:
                                "el-dropdown-menu el-popper el-dropdown-menu--medium",
                            },
                            _vm._l(_vm.fileSortData, function (item, index) {
                              return _c(
                                "li",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        (index !== 4 &&
                                          _vm.switchIndex !== 7) ||
                                        _vm.switchIndex === 7,
                                      expression:
                                        "(index !== 4 && switchIndex !== 7) || switchIndex === 7",
                                    },
                                  ],
                                  key: item.id,
                                  staticClass: "el-dropdown-menu__item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleCommand(item.id)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    class:
                                      _vm.sortIndex - 1 === index
                                        ? "el-icon-check"
                                        : "",
                                    style: {
                                      paddingRight:
                                        _vm.sortIndex - 1 === index
                                          ? "0"
                                          : "15px",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(item.name))]),
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "ul",
                            {
                              staticClass:
                                "el-dropdown-menu el-popper el-dropdown-menu--medium sort-ul",
                            },
                            _vm._l(_vm.fileSort, function (item, index) {
                              return _c(
                                "li",
                                {
                                  key: "sort" + item.id,
                                  staticClass: "el-dropdown-menu__item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleSort(index, item.id)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    class:
                                      _vm.sortValue === index
                                        ? "el-icon-check"
                                        : "",
                                    style: {
                                      paddingRight:
                                        _vm.sortValue === index ? "0" : "15px",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(item.name))]),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mr10 icon-name" },
              [
                _c(
                  "el-dropdown",
                  {
                    staticClass: "el-dropdown sort-dropdown display-align",
                    attrs: { trigger: "click" },
                    on: { command: _vm.handleType },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "el-dropdown-link pointer el-dropdown-selfdefine text-16",
                      },
                      [
                        _vm._v("\n              类型\n              "),
                        _c("i", { staticClass: "icon iconfont iconshaixuan" }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      _vm._l(_vm.fileScreenData, function (item, index) {
                        return _c(
                          "el-dropdown-item",
                          {
                            key: item.id,
                            staticStyle: { width: "120px" },
                            attrs: { command: item.id },
                          },
                          [
                            _c("i", {
                              class:
                                _vm.typeValue === item.id
                                  ? "el-icon-check"
                                  : "",
                              style: {
                                paddingRight:
                                  _vm.typeValue === item.id ? "0" : "15px",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(item.name))]),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "el-dropdown-link pointer text" }, [
              _vm.fileStyle.style == 1
                ? _c("i", {
                    staticClass: "icon iconfont iconkuaizhuangyangshi",
                    on: {
                      click: function ($event) {
                        return _vm.handleFileStyle(2)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.fileStyle.style == 2
                ? _c("i", {
                    staticClass: "icon iconfont iconliebiaoyangshi",
                    on: {
                      click: function ($event) {
                        return _vm.handleFileStyle(1)
                      },
                    },
                  })
                : _vm._e(),
            ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }